/** Escapes minimal HTML entities for Leaflet popup / tooltip snippets. */
export function escapePopupHtml(raw: unknown): string {
  return String(raw ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
